import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {UserXpHistoryService} from "../services/user-xp-history.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReasonComponent} from "../../../../@shared/modals/reason/reason.component";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {Subject} from "rxjs";
import {IXpHistory, IXpHistoryItem} from "../services/interfaces/xp-history.interface";
import {UserService} from "../../../../@shared/services/user.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LogType} from "../../../../@core/enums/log-type.enum";

@Component({
  selector: 'app-xp-history',
  templateUrl: './xp-history.component.html',
  styleUrls: ['./xp-history.component.scss']
})
export class XpHistoryComponent implements AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild('cashbackTableSort', {read: MatSort, static: true}) cashbackTableSort: MatSort;

  public userXpHistoryColumns = ['count', 'type', 'timestamp', 'amount', 'merge'];
  public userXpHistoryData: MatTableDataSource<IXpHistoryItem> = new MatTableDataSource();

  public addXpForm: FormGroup = this.fb.group({
    amount: [null, [Validators.required]],
    comment: ['', [Validators.required]]
  })

  public selectedDate: { start: string, end: string };
  public isLoading = true;
  public logType = LogType;
  private readonly destroyed$: Subject<void> = new Subject<void>();

  public totalRows = 0;
  public pageSize = 10;
  public currentPage = 0;
  public pageSizeOptions: number[] = [10, 25, 50, 100];

  constructor(private userXpHistoryService: UserXpHistoryService,
              private userService: UserService,
              private fb: FormBuilder,
              private dialog: MatDialog) {
    this.subscribeEmitters();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngAfterViewInit() {
    this.userXpHistoryData.sort = this.cashbackTableSort;
  }

  public changeDateFilter(filter: { start: string, end: string }): void {
    this.isLoading = true;
    this.selectedDate = filter;
    this.userXpHistoryService.requestUserXpHistory(filter, this.pageSize, this.currentPage);
    this.userXpHistoryData.data = [];
  }

  public pageChanged(event: PageEvent) {
    this.isLoading = true;
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.userXpHistoryService.requestUserXpHistory(this.selectedDate, this.pageSize, this.currentPage)
  }

  public resetXpBonuses(): void {
    this.dialog.open(ReasonComponent)
      .afterClosed()
      .pipe(
        filter(reason => !!reason),
        switchMap((reason: string) => this.userXpHistoryService.resetUserXpBonuses(reason))
      )
      .subscribe(() => {
          this.userXpHistoryService.requestUserXpHistory(this.selectedDate, this.pageSize, this.currentPage)
          this.userService.requestUser();
        }
      )
  }

  public addXp(): void {
    const {amount, comment} = this.addXpForm.value;
    this.userXpHistoryService.addXp(amount, comment).subscribe(() => {
        this.userXpHistoryService.requestUserXpHistory(this.selectedDate, this.pageSize, this.currentPage)
        this.userService.requestUser();
      }
    )
  }

  private subscribeEmitters(): void {
    this.userXpHistoryService.userXpHistory$
      .pipe(
        takeUntil(this.destroyed$),
        filter((xpHistory: IXpHistory) => !!xpHistory)
      )
      .subscribe((xpHistory: IXpHistory) => {
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = xpHistory.meta.count;
        });
        this.userXpHistoryData.data = xpHistory.items;
        this.isLoading = false;
      })
  }
}
